import { Link, useNavigate } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'
import { Helmet } from 'react-helmet-async'
import { useAuth } from '../hooks/useAuth'
import { AppHeader } from '../components'

export default function NotFoundPage() {
  const navigate = useNavigate()
  const { user, isAuthenticated } = useAuth()

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <>
      <Helmet>
        <title>Page Not Found - FWO Pilot Portal</title>
        <meta name="description" content="The page you're looking for doesn't exist" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        {/* Show navigation for authenticated users */}
        {isAuthenticated && user && <AppHeader />}

        <div className="flex items-center justify-center" style={{ minHeight: isAuthenticated ? 'calc(100vh - 4rem)' : '100vh' }}>
          <div className="max-w-md w-full mx-auto px-4">
            <div className="text-center">
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <div className="bg-white p-4 rounded-full shadow-lg">
                <img 
                  src="/fwo-logo.png" 
                  alt="FlyWideOpen" 
                  className="h-16" 
                />
              </div>
            </div>

            {/* Error Message */}
            <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
            <p className="text-gray-600 mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>

            {/* Action Buttons */}
            <div className="space-y-3">
              {isAuthenticated ? (
                <>
                  <Link
                    to="/dashboard"
                    className="inline-flex items-center justify-center w-full px-6 py-3 bg-fwo-blue text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    <Home className="h-5 w-5 mr-2" />
                    Go to Dashboard
                  </Link>
                  
                  <button
                    onClick={handleGoBack}
                    className="inline-flex items-center justify-center w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <ArrowLeft className="h-5 w-5 mr-2" />
                    Go Back
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/"
                    className="inline-flex items-center justify-center w-full px-6 py-3 bg-fwo-blue text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    <Home className="h-5 w-5 mr-2" />
                    Go to Homepage
                  </Link>
                  
                  <button
                    onClick={handleGoBack}
                    className="inline-flex items-center justify-center w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <ArrowLeft className="h-5 w-5 mr-2" />
                    Go Back
                  </button>
                </>
              )}
            </div>

            {/* Help Text */}
            <div className="mt-8 text-sm text-gray-500">
              <p>If you believe this is an error, please contact support.</p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}